/**
 * Collection List Slider Handler
 * Initializes Swiper sliders for collection-list sections
 */

class CollectionListSliderHandler {
  constructor() {
    this.init();
  }

  init() {
    // Initialize on page load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        this.initializeSliders();
      });
    } else {
      this.initializeSliders();
    }

    // Re-initialize on Shopify section events (Theme Editor)
    document.addEventListener('shopify:section:load', (event) => {
      this.initializeSlidersInSection(event.target);
    });
  }

  initializeSliders() {
    const sliders = document.querySelectorAll('[data-collection-list-slider]');
    sliders.forEach(slider => this.initializeSlider(slider));
  }

  initializeSlidersInSection(section) {
    const sliders = section.querySelectorAll('[data-collection-list-slider]');
    sliders.forEach(slider => this.initializeSlider(slider));
  }

  initializeSlider(swiperContainer) {
    if (!swiperContainer || !window.Swiper) {
      // console.warn('[Collection List] Swiper not available or container not found');
      return;
    }

    // Check if already initialized
    if (swiperContainer.swiper) {
      return;
    }

    const slidesPerViewMobile = parseInt(swiperContainer.getAttribute('data-slides-mobile')) || 2;
    const slidesPerViewDesktop = parseInt(swiperContainer.getAttribute('data-slides-desktop')) || 4;
    const spaceBetweenView = parseInt(swiperContainer.getAttribute('data-slides-space')) || 20;
    const wrapper = swiperContainer.closest('[data-collection-list-slider-wrapper]');

    // console.log(`[Collection List] Initializing Swiper with mobile: ${slidesPerViewMobile}, desktop: ${slidesPerViewDesktop}`);

    const swiper = new Swiper(swiperContainer, {
      slidesPerView: slidesPerViewMobile,
      spaceBetween: 16,
      navigation: {
        nextEl: wrapper ? wrapper.querySelector('.swiper-button-next') : null,
        prevEl: wrapper ? wrapper.querySelector('.swiper-button-prev') : null,
      },
      breakpoints: {
        1024: {
          slidesPerView: slidesPerViewDesktop,
          spaceBetween: spaceBetweenView,
        }
      }
    });

    // console.log('[Collection List] Swiper initialized successfully');
  }
}

// Initialize when script loads
if (typeof window !== 'undefined') {
  window.collectionListSliderHandler = new CollectionListSliderHandler();
}
